// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__20u_Z","filesListContainer":"PosDisputesFiles_filesListContainer__1o2sc","filesButton":"PosDisputesFiles_filesButton__VUrNE"};